import { MODULE_SET, MODULE_RESET, MODULE_SELECTED } from './module.actions';

const initial = {
    selected: null,
    list: []
};

const moduleReducer = (state = initial, action) => {
    switch (action.type) {
        case MODULE_SET:
            return {
                ...state,
                list: action.payload
            }
        case MODULE_RESET:
            return initial;
        case MODULE_SELECTED:
            return {
                ...state,
                selected: action.payload
            };
        default:
            return state;
    }
}

export default moduleReducer;